import { ORIGIN_URL } from 'services/http-client'
import { hostsConfig } from 'init/config'
import urlUtils from 'util/url-utils'

function getSocialRedirectUrl(socialUrl: string, socialUrlParamName: string, shareUrl: string) {
  const params = { socialUrl, socialUrlParamName, shareUrl, siteKey: hostsConfig.siteKey }
  return `${ORIGIN_URL}/social/shortenUrlRedirect?${urlUtils.buildQryString(params)}`
}

function openFacebookShare(shareUrl, quote = null) {
  // Facebook sharer only allows URL and some text to be passed
  let socialUrl = 'https://www.facebook.com/sharer/sharer.php'
  if (quote) {
    socialUrl = `${socialUrl}?quote=${quote}`
  }
  urlUtils.openWindow(getSocialRedirectUrl(socialUrl, 'u', shareUrl))
}

function openPinterestShare(shareUrl, imageUrl, description) {
  const baseUrl = 'https://www.pinterest.com/pin/create/button'
  const queryStr = `media=${imageUrl}&description=${description}`
  urlUtils.openWindow(getSocialRedirectUrl(`${baseUrl}?${queryStr}`, 'url', shareUrl))
}

function openTwitterShare(shareUrl, text) {
  let socialUrl = 'https://twitter.com/intent/tweet'
  if (text) {
    socialUrl = `${socialUrl}?text=${text}`
  }
  urlUtils.openWindow(getSocialRedirectUrl(socialUrl, 'url', shareUrl))
}

export default { openFacebookShare, openPinterestShare, openTwitterShare }
